/**
 * Copyright (c) 2024-present, Bruno Carvalho de Araujo.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in
 * the root directory of this source tree.
 */


export type ResolutionType = 'absolute' | 'less' | 'more' | 'ratio'

export const isResolutionValid = (
  image: HTMLImageElement,
  resolutionType: ResolutionType,
  resolutionWidth: number = 0,
  resolutionHeight: number = 1
): boolean => {
  if (!resolutionWidth || !resolutionHeight || !image.width || !image.height) {
    return true
  }

  switch (resolutionType) {
    case 'absolute': {
      if (image.width === resolutionWidth && image.height === resolutionHeight) {
        return true
      }
      break
    }
    case 'ratio': {
      const ratio: number = resolutionWidth / resolutionHeight
      if (image.width / image.height === ratio) {
        return true
      }

      break
    }
    case 'less': {
      if (image.width <= resolutionWidth && image.height <= resolutionHeight) {
        return true
      }
      break
    }
    case 'more': {
      if (image.width >= resolutionWidth && image.height >= resolutionHeight) {
        return true
      }
      break
    }
    default:
      break
  }
  return false
}

export const getImage = (file: File): Promise<HTMLImageElement> => {
  const image = new Image()
  return new Promise((resolve) => {
    image.addEventListener('load', () => resolve(image))
    image.src = URL.createObjectURL(file)
  })
}

export const getBase64 = (file: File): Promise<string> => {
  return new Promise(resolve => {
    const reader = new FileReader()
    reader.addEventListener('load', () => resolve(String(reader.result)))
    reader.readAsDataURL(file)
  })
}

export const isImageValid = (fileType: string): boolean => {
  if (fileType?.includes('image')) {
    return true
  }

  return false
}

export const isVideoValid = (fileType: string): boolean => {
  return fileType === 'video/mp4' || fileType === 'video/webm'
}
